import { compose, hoistStatics, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import KnowledgeBase from './KnowledgeBase';
import WithLoading from '../../../components/WithLoading';
import ModuleService from '../../../services/module.service';
import { settingsActions } from '../../../reducers/settings';

// todo: highlight words
// const regEx = new RegExp(`(${word})(?!([^<]+)?>)`, 'gi');
// const output = post.title ? post.title.replace(regEx, '<strong>{word}</strong>') : '';

const callbackToSetSearch = props => async (value) => {
  const {
    history,
    setActivePost,
    setActiveCategory,
    setShowBack } = props;
  setShowBack(false);
  setActiveCategory(null);
  setActivePost(null);
  if (value) {
    history.push(`/kb/search-${value}`);
  } else { history.push('/kb'); }
};


const defaultCriteriaPost = {
  sortBy: 'created_at',
  order: 'desc',
  limit: 11,
  page: 0,
};

const defaultCriteriaPostSearch = {
  ...defaultCriteriaPost, limit: 10,
};

const goBack = ({ setShowBack }) => (e) => {
  e.preventDefault();
  setShowBack(false);
};

const choosePost = props => async (e, post) => {
  // clear search
  const { history, setUpdateSearch, updateSearch } = props;
  e.preventDefault();
  setUpdateSearch(!updateSearch);
  history.push(`/kb/${post.id}`);
};

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('posts', 'setPosts', []),
  withState('isLoad', 'setIsLoad', true),
  withState('showBack', 'setShowBack', false),
  withState('postsCount', 'setPostsCount', 0),
  withState('isLoading', 'setIsLoading', false),
  withState('categories', 'setCategories', []),
  withState('activePost', 'setActivePost', null),
  withState('activeCategory', 'setActiveCategory', null),
  withState('postsCriteria', 'setPostsCriteria', defaultCriteriaPost),
  withState('searchedPostsCount', 'setSearchedPostsCount', 0),
  withState('searchCriteria', 'setSearchCriteria', defaultCriteriaPostSearch),
  withState('updateSearch', 'setUpdateSearch', false),
  lifecycle({
    async componentDidMount() {
      this.props.updateSettings({ hasLoadedPage: true });
    },
  }),
  withProps(props => ({
    moduleTitle: props.modulesSettings[ModuleService.TYPE_KB].title || props.t('Knowledge base'),
    backgroundColor: props.modulesSettings[ModuleService.TYPE_KB].color ?
      props.modulesSettings[ModuleService.TYPE_KB].color :
      props.modulesSettings[ModuleService.TYPE_KB].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_KB].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_KB].enable_cover_color,
  })),
  withHandlers({
    goBack,
    choosePost,
    callbackToSetSearch,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(KnowledgeBase)));



// WEBPACK FOOTER //
// ./src/views/modules/kb/index.js